import type { InstructorCue } from './types';

export const resolveInstructorCues=(cues:InstructorCue[]|undefined)=>cues?.filter(cue=>cue.script.trim()&&cue.caption.trim())??[];
